import FavoriteIcon from './FavoriteIconUpdate';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LayerGroupIcon from './LayerGroupIcon';
import { Link } from 'react-router-dom';
import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import strings from '../utility/strings.js';

const StationItem = (props) => {
  const {
    favorites,
    components,
    currentUser,
    isFlaggedForCurrentUser,
    specialName,
    isNutritionReady,
    itemId,
    name,
    traits,
    GET_USER,
    mealName,
    dateFull,
    collectionId,
    collectionName,
    hasComponents,
    itemMenuId,
    linkToMenuId,
    params } = props;

  let hiddenItem = "";
  let flagged = "";
  let logClass = currentUser !== 'Guest' ? '_fancy' : '_plain';

  let lastString;
  let lastPath;
  
  const menuId = linkToMenuId ? "/" + itemMenuId : '';

  //console.log("Rendering StationItem for itemId:", itemId, props, 'isfalgged', isFlaggedForCurrentUser, 'compoentns', components, isNutritionReady);

  if(params) {
    lastString = `${params.locationName} - ${dateFull} - ${mealName}`;
    lastPath = `/${params.locationName}/${params.year}/${params.month}/${params.day}/${encodeURIComponent(mealName)}`;
  } else {
    lastString = `Return to ${collectionName}`;
    lastPath = `/item/${collectionId}`;
  }
  if (isFlaggedForCurrentUser) {
    flagged = " item-flagged ";
    return (
      <div className={"station-item--container" + logClass + flagged}>
        <FavoriteIcon favorites={favorites} currentUser={currentUser} GET_USER={GET_USER} itemId={itemId} />
        <Link to={"/item/" + itemId + menuId} className={"station-item " + hiddenItem} state={{ lastString: lastString, lastPath: lastPath }}>
          <div className="station-item-details">
            <span className="station-item-text">{specialName !== null ? specialName : name}</span>

            {
              traits ?
                traits.length !== 0 ? <div className="station-item--icon">{
                  traits.map((g, i) => {
                    return (
                      <img key={g.name + "_" + i} className={g.type === "Preference" ? g.name === 'Vegan' ? " station-item--icon__preference vegan " : "station-item--icon__preference" : "station-item--icon__allergen"} src={g.svgIconWithoutBackground} width="25" height="25" alt={g.name} title={g.name} />
                    )
                  })}</div>
                  :
                  null
                :
                null
            }
          </div>
          <div className="station-item--arrow">
            <KeyboardArrowRightIcon className="action-indicator" aria-hidden="true" />
          </div>
        </Link>
      </div>
    );
  } else if (hasComponents) { //components && components.length > 0) {
    // Parstock Item
    return <div className={"station-item--container" + logClass}>
      {currentUser !== undefined ? <FavoriteIcon favorites={favorites} currentUser={currentUser} itemId={itemId} /> : null}
      <Link to={"/item/" + itemId + menuId} className="station-item" state={{ lastString: lastString, lastPath: lastPath }}>
        <div className="station-item-details">
          <span className="station-item-text">{specialName !== null ? specialName : name}</span>
          {<div className="station-item-traits"><LayerGroupIcon aria-hidden="true" /> Collection</div>}
        </div>
        <div className="station-item--arrow">
          <KeyboardArrowRightIcon className="action-indicator" aria-hidden="true" />
        </div>
      </Link>
    </div>
  }
  else {
    if (isNutritionReady) {
      return (
        <div className={"station-item--container" + logClass}>
          {currentUser !== undefined ? <FavoriteIcon favorites={favorites} currentUser={currentUser} itemId={itemId} /> : null}
          <Link to={"/item/" + itemId + menuId} className="station-item" state={{ lastString: lastString, lastPath: lastPath }}>
            <div className="station-item-details">
              <span className="station-item-text">{specialName !== null ? specialName : name}</span>
              {
                traits ?
                  traits.length !== 0 ? <div className="station-item--icon">{
                    traits.map((g, i) => {
                      return (
                        <img key={g.name + "_" + i} className={g.type === "Preference" ? g.name === 'Vegan' ? " station-item--icon__preference vegan " : "station-item--icon__preference" : "station-item--icon__allergen"} src={g.svgIconWithoutBackground} data-icon={g.svgIcon} width="25" height="25" alt={g.name} title={g.name} />
                      )
                    })}</div>
                    :
                    null
                  :
                  null
              }
            </div>
            <div className="station-item--arrow">
              <KeyboardArrowRightIcon className="action-indicator" aria-hidden="true" />
            </div>
          </Link>
        </div>
      )

    } else {
      return (
        <div className={"station-item--container" + logClass}>
          {currentUser !== undefined ? <FavoriteIcon favorites={favorites} currentUser={currentUser} itemId={itemId} /> : null}
          <Link to={"/item/" + itemId + menuId} state={{ lastString: lastString, lastPath: lastPath }} className="station-item">
            <div className="station-item-details">
              <span className="station-item-text">{specialName !== null ? specialName : name}</span>
              <div className="station-item-traits warning">{isNutritionReady ? null : <><WarningIcon aria-label="Warning" /> {strings.nullAllergens}</>} </div>
            </div>
            <div className="station-item--arrow">
              <KeyboardArrowRightIcon className="action-indicator" aria-hidden="true" />
            </div>
          </Link>
        </div>
      );
    }
  }
}

export default StationItem;